var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('button',{staticClass:"purchaseButton",style:({ width: _vm.width, height: _vm.height, borderRadius: _vm.borderRadius, fontSize: _vm.fontSize }),on:{"click":_vm.openPurchaseModal}},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }